import { useHomeSettings } from "~/lib/home-settings"

export function Footer() {
  const homeSettings = useHomeSettings()
  const year = new Date().getFullYear()

  const footerColumns = [
    {
      title: "Produits",
      links: [
        { name: "DENDROMAP", href: "#solutions" },
        { name: "DENDROMAP+", href: "#solutions" },
        { name: "DENDROCARE", href: "https://dendrocare.fr", external: true },
      ],
    },
    {
      title: "Support",
      links: [
        { name: "Centre d'aide", href: "#", comingSoon: true },
        { name: "Documentation", href: "#", comingSoon: true },
        { name: "Contact", href: "#contact" },
      ],
    },
    {
      title: "Légal",
      links: [
        { name: "Politique de confidentialité", href: "/politique-de-confidentialite" },
        { name: "Conditions d'utilisation", href: "/politique-de-confidentialite" },
        { name: "Mentions légales", href: "/politique-de-confidentialite" },
      ],
    },
  ]

  return (
    <footer className="bg-[#071a11] text-white">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8 pt-16 pb-8">
        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-12 mb-16">

          {/* ─── Brand ──────────────────────────────────────────────── */}
          <div>
            <img
              src="/images/logo-name/white.svg"
              alt={homeSettings.brand.logo.text}
              className="h-10 w-auto mb-5"
            />
            <p className="text-white/50 text-sm leading-[1.7] mb-6 max-w-[220px]">
              La référence française pour la gestion, la cartographie et l'inventaire de votre patrimoine arboré.
            </p>
            <a
              href="mailto:contact@dendromap.fr"
              className="text-emerald-400 text-sm hover:text-emerald-300 transition-colors"
            >
              contact@dendromap.fr
            </a>
          </div>

          {/* ─── Link columns ───────────────────────────────────────── */}
          {footerColumns.map((section) => (
            <div key={section.title}>
              <h4 className="text-[11px] font-semibold tracking-[0.14em] text-white/30 uppercase mb-5">
                {section.title}
              </h4>
              <ul className="space-y-3.5">
                {section.links.map((link) => (
                  <li key={link.name}>
                    {link.comingSoon ? (
                      <span className="flex items-center gap-2 text-white/28 text-sm cursor-default">
                        {link.name}
                        <span className="text-[9px] font-medium bg-white/8 text-white/30 px-1.5 py-0.5 rounded uppercase tracking-wider">
                          Bientôt
                        </span>
                      </span>
                    ) : link.external ? (
                      <a
                        href={link.href}
                        target="_blank"
                        rel="noopener noreferrer"
                        className="text-white/50 text-sm hover:text-emerald-400 transition-colors inline-flex items-center gap-1"
                      >
                        {link.name}
                        <svg className="size-3 opacity-60" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden>
                          <path d="M2.5 9.5L9.5 2.5M9.5 2.5H4.5M9.5 2.5V7.5" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
                        </svg>
                      </a>
                    ) : (
                      <a
                        href={link.href}
                        className="text-white/50 text-sm hover:text-white transition-colors"
                      >
                        {link.name}
                      </a>
                    )}
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        {/* ─── Bottom bar ─────────────────────────────────────────────── */}
        <div className="border-t border-white/[0.07] pt-8 flex flex-col sm:flex-row justify-between items-center gap-3">
          <p className="text-white/25 text-xs">
            © {year} Dendromap® — RACINES ET CIMES. Tous droits réservés.
          </p>
          <p className="text-white/18 text-xs italic">
            Conçu pour les arboristes, par des arboristes.
          </p>
        </div>
      </div>
    </footer>
  )
}
